export default "__VITE_ASSET__B6BM5Wqs__"